<template>
  <div id="gallery">
    <header>
      <h1>
        <font-awesome-icon icon="images" />
        {{ name }}
      </h1>
      <p v-if="description" v-text="description"></p>
    </header>

    <gallery-section
      v-for="section in sections"
      :key="section.name()"
      :section="section"
    ></gallery-section>
  </div>
</template>

<script>
import GallerySection from './GallerySection.vue';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['currentResource']),

    gallery() {
      return this.currentResource.gallery();
    },

    sections() {
      return this.gallery.sections();
    },

    name() {
      return this.gallery.name();
    },

    description() {
      return this.gallery.description();
    },
  },

  components: {
    GallerySection,
  },
};
</script>

<style lang="scss" scoped>
#gallery {
  padding: 1rem;

  header {
    margin: 2rem 0;
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-end;
  }

  h1 {
    margin: 0;
    padding: 0;
  }

  p {
    font-size: 1.2rem;
    padding: 0;
    margin: 1rem 0 0;
  }

  h1,
  p {
    color: #222;

    @include dark {
      color: #ccc;
    }
  }
}
</style>
